// extracted by mini-css-extract-plugin
export default {"errorText":"hoursTable_errorText__-ytw5","errorBorder":"hoursTable_errorBorder__wR0hl"};